import React from 'react';

function ToggleSwitch({ label, defaultChecked, onChange }) {
    return (
        <div className="flex items-center status-badge">
            <span className="mr-4">{label}</span>
            <div className="relative inline-block w-10 h-5 align-middle select-none">
                <input
                    id={`toggle-switch-${label}`}
                    type="checkbox"
                    defaultChecked={defaultChecked}
                    onChange={onChange}
                    className="hidden peer" // Hide the default checkbox
                />
                <label
                    htmlFor={`toggle-switch-${label}`}
                    className={`block w-10 h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
                            ${defaultChecked ? 'bg-green-500' : 'bg-gray-200'}`}
                >
                    {/* Toggle circle */}
                    <span
                        className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out
                                ${defaultChecked ? 'translate-x-5' : 'translate-x-0'}`}
                    />
                </label>
            </div>
        </div>
    );
}

export default ToggleSwitch;